/*
* ------------------------------------------------------------------------------
* DETAILS ACCORDION CUSTOM ELEMENT
* --------------------------------
* Copyright 2021 Elkfox Co Pty Ltd - All rights reserved
* ------------------------------------------------------------------------------
*/

if (customElements.get('details-accordion') === undefined) {
  class DetailsAccordion extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.body = Array.prototype.slice.call(this.details.children).find(element => element != this.summary);
      this.transitioning = false;
      this.details.style.overflow = 'hidden';
      this.summary.addEventListener('click', this.toggle.bind(this));
    }

    toggle() {
      event.preventDefault();
      if (!this.transitioning && !this.details.open) { this.open() }
      else if (!this.transitioning && this.details.open) { this.close() };
    }

    open() {
      this.transitioning = true;
      this.details.open = true;
      this.body.style.height = `${this.body.offsetHeight}px`;
      this.animation = this.body.animate({ height: [0, this.body.offsetHeight] }, { duration: 400, easing: 'ease-out' });
      this.animation.onfinish = () => { this.transitioning = false };
    }

    close() {
      this.transitioning = true;
      this.animation = this.body.animate({ height: [this.body.offsetHeight, 0] }, { duration: 400, easing: 'ease-out' });
      this.animation.onfinish = () => { this.details.open = false, this.transitioning = false };
    }
  }

  customElements.define('details-accordion', DetailsAccordion);
}
